import axios from 'axios';
import { logger } from '../../../utils/logger';

interface InitiateCallResponse {
  success: boolean;
  message?: string;
}

class PhoneEndpoint {
  private static instance: PhoneEndpoint;
  private readonly twilioEndpoint: string;

  private constructor() {
    // Remove any surrounding quotes from the env value
    const endpoint = import.meta.env.VITE_TWILIO_ENDPOINT || '';
    this.twilioEndpoint = endpoint.replace(/^['"]|['"]$/g, '');
  }

  static getInstance(): PhoneEndpoint {
    if (!PhoneEndpoint.instance) {
      PhoneEndpoint.instance = new PhoneEndpoint();
    }
    return PhoneEndpoint.instance;
  }

  async initiateTestCall(
    clientId: string,
    phoneNumber: string,
    country: string
  ): Promise<InitiateCallResponse> {
    try {
      if (!this.twilioEndpoint) {
        throw new Error('Twilio endpoint not configured');
      }

      const response = await axios.post<InitiateCallResponse>(
        `${this.twilioEndpoint}?clientId=${clientId}&country=${country}`,
        { phoneNumber },
        { timeout: 30000 }
      );

      logger.info('Test call initiated successfully', { clientId, phoneNumber, country });
      return response.data;
    } catch (error) {
      logger.error('Failed to initiate test call:', error);
      throw error;
    }
  }
}

export const phoneEndpoint = PhoneEndpoint.getInstance();
